'use client';

import { useEffect } from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';
import { setLocale } from '@/i18n/request';
import { Locale, LOCALES } from '@ui/lib/locale';

interface LocaleDetectorProps {
  setLanguage?: (locale: Locale) => void;
}

export default function LocaleDetector({ setLanguage }: LocaleDetectorProps) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const locale = searchParams.get('locale');

    if (!locale || !LOCALES.includes(locale as Locale)) return;

    setLocale(locale)
      .then(() => {
        // Remove the locale parameter from the URL after setting it
        const newSearchParams = new URLSearchParams(searchParams.toString());
        newSearchParams.delete('locale');

        // Build the new URL without the locale parameter
        const newUrl = pathname + (newSearchParams.toString() ? `?${newSearchParams.toString()}` : '');

        router.replace(newUrl);
        setLanguage?.(locale as Locale);
      })
      .catch((error) => {
        console.warn('Failed to set locale:', error);
      });
    searchParams;
  }, [pathname, router, searchParams, setLanguage]);

  // This component doesn't render anything visible
  return null;
}
